<script setup>
  import Hft_GoToMainBtn from '@/components/microsites/HeadingForTomorrow/components/Hft_GoToMainBtn.vue'
  import Hft_MobileNav from '@/components/microsites/HeadingForTomorrow/components/Hft_MobileNav.vue'
  import Hft_Nav from '@/components/microsites/HeadingForTomorrow/components/Hft_Nav.vue'
  import Hft_Dave from '@/components/microsites/HeadingForTomorrow/section/Hft_Dave.vue'
  import Hft_HeroSection from '@/components/microsites/HeadingForTomorrow/section/Hft_Hero.vue'
  import Hft_MoreCharactersSection from '@/components/microsites/HeadingForTomorrow/section/Hft_MoreCharacters.vue'
  import Hft_MorningSection from '@/components/microsites/HeadingForTomorrow/section/Hft_Morning.vue'
  import Hft_SiaSection from '@/components/microsites/HeadingForTomorrow/section/Hft_Sia.vue'
  // import Hft_VictoriaSection from '@/components/microsites/HeadingForTomorrow/section/Hft_Victoria.vue'
  import Cookie from '@/services/browser/Cookie'
  import Responsive from '@/services/browser/Responsive'
  import { onMounted } from 'vue'
  onMounted(() => {
    Responsive.init()
    Cookie.set('stargazer', 'true')
    window.dataLayer.push({
      pageType: 'Microsite',
      micrositeName: 'StarGazer',
      micrositePhase: '2',
    })
  })

  const navItems = [
    { id: 'Menu-v261', name: 'V.261 Content' },
    { id: 'Menu-sia', name: 'Sia Astelle' },
    { id: 'Menu-v260', name: 'V.260 Content' },
  ]
</script>

<template>
  <div class="m-headingForT">
    <Hft_HeroSection data-section-number="0" data-section-name="Hero" />
    <Hft_GoToMainBtn />
    <Hft_Nav :nav-items="navItems" data-section-number="0" data-section-name="Desktop Nav" />
    <Hft_MobileNav :nav-items="navItems" />
    <Hft_Dave id="Menu-v261" data-section-number="1" data-section-name="Dave" />
    <Hft_SiaSection id="Menu-sia" data-section-number="2" data-section-name="Sia" />
    <Hft_MorningSection data-section-number="3" data-section-name="Morning Star Banquet" />
    <Hft_MoreCharactersSection data-section-number="4" data-section-name="More Changes For A Better Maple" />
    <!-- <Hft_VictoriaSection data-section-number="4" data-section-name="Victoria Cup" /> -->
    <Footer
      color="#fbedd5"
      hover-color="#ff9934"
      background-color="#002343"
      data-section-number="99"
      data-section-name="Footer"
      data-interaction="link_click"
    />
  </div>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/DemonSlayerCollab/fonts.scss';
  @use '@/assets/scss/microsites/DemonSlayerCollab/variables.scss' as *;

  .m-headingForT {
    color: $generalTextColor;
    font-family: 'Quantico', sans-serif;
    font-weight: 400;
    font-style: normal;
    color: white;
    background: black;
    font-size: 1.2vw;
    line-height: 1.2em;
  }
  .m-headingForT__main-content {
    padding: 4vw 0 4vw;
    overflow: hidden;
    z-index: 3;
    position: relative;
  }
  footer {
    padding-top: 5vw !important;
  }
  .tablet {
    .m-headingForT {
      font-size: 2.3vw;
    }
    footer {
      padding-top: 10vw !important;
    }
  }
  .mobile {
    .m-headingForT {
      font-size: 4.6vw;
    }
    footer {
      padding-top: 10vw !important;
    }
  }
</style>
